<script>
import apiTokenModal from "../form/api-token";

export default {
  name: "apiInformation",
  components: {
    apiTokenModal,
  },
  computed: {
    shouldShowTokenModals: function () {
      const sku = _.get($A, 'Auth.account.subscriptionState.sku', []);
      const countOfRedeemedCodesOfTheSameSku = _.get($A, 'Auth.account.subscriptionState.countOfRedeemedCodesOfTheSameSku', 0);

      return sku.indexOf('api') > 0 || (sku.indexOf('enterprise-code-stacking-1') !==-1 && countOfRedeemedCodesOfTheSameSku === 10)
    },
  },
  methods: {
    get(object, path, defaultValue) {
      return _.get(object, path, defaultValue);
    },
  },
};
</script>

<template>
  <div class="settings-card" v-show="shouldShowTokenModals">
    <div class="card-head">
      <div class="card-head-title">API Information</div>
      <div class="card-head-subtitle">Use these tokens to authenticate with the Ashore API.</div>
    </div>
    <div class="card-body">
      <div class="field">
        <label class="field-label">User Token</label>
        <apiTokenModal :api-token="get($A, 'Auth.apiToken.token', '')"/>
      </div>
      <div class="field">
        <label class="field-label">Refresh Token</label>
        <apiTokenModal :api-token="get($A, 'Auth.apiToken.refreshToken', '')"/>
      </div>
    </div>
    <div class="card-foot">
      <b-button
          :href="$A.Env.apiHost + '/swagger'"
          target="nk"
          class="secondary-btn"
      >API Endpoints</b-button>
      <b-button
          href="/knowledge-base-article?slug=how-do-i-use-access-tokens-and-refresh-tokens"
          target="nk"
          class="secondary-btn"
      >API Guide</b-button>
    </div>
  </div>
</template>

<style scoped>
.settings-card {
  background: #fff;
  border: 1px solid rgba(15, 23, 42, 0.06);
  border-radius: 12px;
  box-shadow: 0 1px 2px rgba(8, 11, 13, 0.04), 0 8px 24px -16px rgba(8, 11, 13, 0.1);
}
.card-head {
  padding: 14px 20px;
  background: #fbfbfc;
  border-bottom: 1px solid rgba(15, 23, 42, 0.06);
  border-radius: 12px 12px 0 0;
}
.card-head-title {
  font-size: 15px;
  font-weight: 600;
  color: #111827;
}
.card-head-subtitle {
  margin-top: 1px;
  font-size: 12.5px;
  font-weight: 400;
  color: #6b7280;
}
.card-body {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 20px;
}
.card-foot {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding: 12px 20px;
  background: #fbfbfc;
  border-top: 1px solid rgba(15, 23, 42, 0.06);
  border-radius: 0 0 12px 12px;
}
.field-label {
  display: block;
  font-size: 11px;
  font-weight: 700;
  color: #6b7280;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  margin-bottom: 6px;
}
.secondary-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 36px;
  padding: 0 14px;
  background: #fff !important;
  color: #1f2937 !important;
  border: 1px solid rgba(15, 23, 42, 0.12) !important;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  text-decoration: none;
}
.secondary-btn:hover,
.secondary-btn:focus {
  border-color: #019256 !important;
  color: #019256 !important;
  text-decoration: none;
}
</style>
